import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import "./i18n"; // Import i18n config

// 1. Import the AI Kernel Provider
import { AIKernelProvider } from './components/Shortener/hooks/AIKernel'; 

// 2. Import your data (so the AI knows what content it is sorting/recommending)
// Adjust this path based on where your dataportfolio is actually located
import { dataportfolio } from './components/Shortener/hooks/content_option'; 

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* 3. Wrap the application in the AI Cognitive Loop */}
      <AIKernelProvider portfolioData={dataportfolio}>
        <App />
      </AIKernelProvider>
    </BrowserRouter>
  </React.StrictMode>
);